export default "__VITE_PUBLIC_ASSET__0e0eccef__"